<section class="container-fluid pt-4">

  <!-- Header -->
  <div class="row align-items-center justify-content-between mb-4">
    <div class="col-lg-6 col-md-8 col-sm-12">
      <h2 class="fw-bold text-dark mb-0">
        <i class="fas fa-wallet me-2 text-primary"></i>Manage Pricing Plans
      </h2>
    </div>
    <div class="col-lg-3 col-md-4 col-sm-12 text-lg-end mt-3 mt-lg-0">
      <button class="btn btn-success rounded-pill shadow-sm px-4" (click)="openAddModal()">
        <i class="fas fa-plus me-2"></i>Add New Plan
      </button>
    </div>
  </div>

  <!-- Pricing Cards -->
  <div class="row g-4">
    <div class="col-xl-3 col-lg-4 col-md-6 col-sm-12 d-flex" *ngFor="let plan of pricingPlans; let i = index">
      <div class="pricing-card card border-0 rounded-4 flex-fill position-relative hover-card"
        [ngStyle]="{'background-color': cardColors[i % cardColors.length]}">

        <div *ngIf="plan.tag" class="badge-custom position-absolute top-0 end-0 mt-3 me-3">
          {{ plan.tag }}
        </div>

        <div class="card-header text-white border-0 rounded-top-4 text-center py-4"
          [ngStyle]="{'background-color': headerColors[i % headerColors.length]}">
          <h5 class="fw-bold mb-1 text-capitalize">{{ plan.packageName || 'Unnamed Plan' }}</h5>
          <p *ngIf="plan.description" class="mb-0 fs-6" style="opacity: 0.85;">
            {{ plan.description }}
          </p>
        </div>

        <div class="card-body d-flex flex-column text-center p-4">
          <!-- Prices -->
          <h2 class="fw-bold text-dark mb-4">
            <span *ngIf="plan.isMonthly">
              ₹{{ plan.priceMonthly || 0 }} <span class="fs-6 text-muted">/month</span>
            </span>
            <span *ngIf="plan.isMonthly && plan.isYearly"> &nbsp; | &nbsp; </span>
            <span *ngIf="plan.isYearly">
              ₹{{ plan.priceYearly || 0 }} <span class="fs-6 text-muted">/year</span>
            </span>
          </h2>

          <!-- Features -->
          <ul class="list-unstyled text-start mb-4 flex-grow-1">
            <li *ngFor="let feature of plan.featureDetails" class="mb-2 d-flex align-items-center">
              <i class="fas fa-check-circle me-2 text-success" *ngIf="feature.value === 'yes'"></i>
              <i class="fas fa-times-circle me-2 text-danger" *ngIf="feature.value === 'no'"></i>
              <i class="fas fa-check-circle me-2 text-success"
                *ngIf="feature.value && feature.value !== 'yes' && feature.value !== 'no'"></i>
              <span>{{ feature.featureName }}
                <span class="text-muted" *ngIf="feature.value && feature.value !== 'yes' && feature.value !== 'no'">
                  - {{ feature.value }}
                </span>
              </span>
            </li>
          </ul>

          <!-- Buttons -->
          <div class="d-flex gap-2 mt-auto">
            <button class="btn btn-outline-primary flex-fill rounded-pill" (click)="openAddModal(plan)">
              <i class="fas fa-pen me-1"></i>Edit
            </button>
            <button class="btn btn-outline-danger flex-fill rounded-pill" (click)="deletePackage(plan)">
              <i class="fas fa-trash me-1"></i>Delete
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Add/Edit Modal -->
  <div class="modal fade" id="addPackageModal" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered modal-lg">
      <div class="modal-content rounded-4 border-0 shadow-lg">
        <div class="modal-header bg-light border-0">
          <h5 class="modal-title fw-bold">
            {{ addPackageForm.value.packageId ? 'Edit Package' : 'Add New Package' }}
          </h5>
          <button type="button" class="btn-close" (click)="addModal?.hide()" aria-label="Close"></button>
        </div>

        <div class="modal-body p-4">
          <form [formGroup]="addPackageForm" (ngSubmit)="savePackage()">
            <div class="row g-3">

              <!-- Package Name -->
              <div class="col-md-6">
                <label class="form-label fw-semibold">Package Name <span class="text-danger">*</span></label>
                <input type="text" class="form-control rounded-3" placeholder="Enter package name"
                  formControlName="packageName" />
                <small class="text-danger" *ngIf="submitted && addPackageForm.get('packageName')?.hasError('required')">
                  Package name is required
                </small>
              </div>

              <!-- Status -->
              <div class="col-md-6">
                <label class="form-label fw-semibold">Status <span class="text-danger">*</span></label>
                <select class="form-select rounded-3" formControlName="packageStatus">
                  <option [value]="PackageStatus.ACTIVE">Active</option>
                  <option [value]="PackageStatus.INACTIVE">Inactive</option>
                </select>
                <small class="text-danger"
                  *ngIf="submitted && addPackageForm.get('packageStatus')?.hasError('required')">
                  Please select status
                </small>
              </div>

              <!-- Monthly Price -->
              <div class="col-md-6">
                <div class="d-flex align-items-center gap-3 mb-2">
                  <label class="form-label fw-semibold mb-0">Monthly Price <span class="text-danger">*</span></label>
                  <div class="form-check form-switch mb-0 ms-5">
                    <input class="form-check-input" type="checkbox" formControlName="isMonthly">
                    <label class="form-check-label">Show</label>
                  </div>
                </div>
                <input type="number" class="form-control rounded-3"
                       placeholder="Enter monthly price"
                       formControlName="priceMonthly"
                       [disabled]="!addPackageForm.get('isMonthly')?.value" />
                <small class="text-danger"
                       *ngIf="submitted && addPackageForm.get('priceMonthly')?.hasError('required') && addPackageForm.get('isMonthly')?.value">
                  Monthly price is required
                </small>
              </div>

              <!-- Yearly Price -->
              <div class="col-md-6">
                <div class="d-flex align-items-center gap-3 mb-2">
                  <label class="form-label fw-semibold mb-0">Yearly Price <span class="text-danger">*</span></label>
                  <div class="form-check form-switch mb-0 ms-5">
                    <input class="form-check-input" type="checkbox" formControlName="isYearly">
                    <label class="form-check-label">Show</label>
                  </div>
                </div>
                <input type="number" class="form-control rounded-3"
                       placeholder="Enter yearly price"
                       formControlName="priceYearly"
                       [disabled]="!addPackageForm.get('isYearly')?.value" />
                <small class="text-danger"
                       *ngIf="submitted && addPackageForm.get('priceYearly')?.hasError('required') && addPackageForm.get('isYearly')?.value">
                  Yearly price is required
                </small>
              </div>

              <!-- Description -->
              <div class="col-12">
                <label class="form-label fw-semibold">Description</label>
                <textarea class="form-control rounded-3" rows="3" placeholder="Enter package description"
                  formControlName="description"></textarea>
              </div>

              <!-- Features Section -->
              <div class="col-12 mt-3" formArrayName="pricingFeature">
                <label class="form-label fw-semibold">Features <span class="text-danger">*</span></label>

                <div *ngFor="let feature of features.controls; let i = index" [formGroupName]="i"
                  class="border rounded-3 p-3 mb-3 bg-light-subtle">

                  <div class="input-group mb-2">
                    <input type="text" class="form-control rounded-start-3" formControlName="featureName"
                      placeholder="Enter feature" />
                    <button type="button" class="btn btn-danger rounded-end-3" (click)="removeFeatureField(i)"
                      [disabled]="features.length === 1">
                      <i class="fas fa-trash me-1"></i>
                    </button>
                  </div>
                  <small class="text-danger d-block mb-2"
                    *ngIf="submitted && feature.get('featureName')?.hasError('required')">
                    Feature name is required
                  </small>

                  <label class="form-label fw-semibold mb-2 d-block">Feature Value <span
                      class="text-danger">*</span></label>

                  <div class="d-flex align-items-center flex-wrap gap-3">
                    <div class="form-check form-check-inline">
                      <input class="form-check-input" type="radio" [checked]="feature.value.hasOption === 'yes'"
                        (change)="setFeatureValue(i,'yes')" id="yes-{{i}}" />
                      <label class="form-check-label" for="yes-{{i}}">Yes</label>
                    </div>

                    <div class="form-check form-check-inline">
                      <input class="form-check-input" type="radio" [checked]="feature.value.hasOption === 'no'"
                        (change)="setFeatureValue(i,'no')" id="no-{{i}}" />
                      <label class="form-check-label" for="no-{{i}}">No</label>
                    </div>

                    <div class="flex-grow-1">
                      <label class="form-label mb-3 small text-muted"
                        for="text-{{i}}">(or) Custom Text:</label>
                      <input id="text-{{i}}" type="text" class="form-control w-auto d-inline-block ms-1"
                        placeholder="Enter custom value..." [value]="feature.value.extraValue"
                        (input)="setFeatureValue(i,$event.target.value)" style="min-width: 180px;" />
                    </div>
                  </div>

                  <small class="text-danger mt-2 d-block" *ngIf="submitted && !featureValid(feature)">
                    Please select Yes or No, or enter a custom value
                  </small>
                </div>

                <button type="button" class="btn btn-secondary btn-sm rounded-pill mt-2" (click)="addFeatureField()">
                  <i class="fas fa-plus me-2"></i>Add Feature
                </button>
              </div>

            </div>

            <div class="mt-4 text-end">
              <button type="button" class="btn btn-outline-secondary rounded-pill me-2"
                (click)="addModal?.hide()">Cancel</button>
              <button type="submit" class="btn btn-primary rounded-pill px-4">
                {{ addPackageForm.value.packageId ? 'Update Package' : 'Save Package' }}
              </button>
            </div>

          </form>
        </div>
      </div>
    </div>
  </div>

</section>
